<template>
    <div class="buttons">
        <b-button variant="default" @click="$bvModal.show(modalId)">
            <font-awesome-icon :icon="['fas', 'eye']" />
        </b-button>
        <modal title="Original Request" scrollable ok-only :id="modalId">
            <span v-html="request"></span>
        </modal>
    </div>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';
export default {
    components: {
        Modal,
    },
    data() {
        return {
            modalId: null,
            request: null,
        };
    },
    mounted() {
        this.modalId = this.params?.data?.id.toString();
        this.request = this.params?.data?.original_request;
    },
};
</script>

<style lang="scss" scoped>
    .buttons {
        display: flex;
        justify-content: center;
    }
</style>
